import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import React from 'react'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { setSaveState } from '../../services/redux/savestate/savestate-actions'
import CheckIcon from '@mui/icons-material/Check';

interface SaveButtonProps {
    onClick: () => void
    disabled?: boolean
    /**
     * save: ULOŽIT
     * saveAndAdd: ULOŽIT A PŘIDAT DALŠÍHO
     */
    variant: 'save' | 'saveAndAdd'
}

const SaveButton: React.FC<SaveButtonProps> = ({ onClick, disabled, variant }: SaveButtonProps) => {
    const dispatch = useAppDispatch()

    const handleSave = () => {
        dispatch(setSaveState(true))
        onClick()
    }

    return (
        <Button variant={variant === 'save' ? 'contained' : 'outlined'} disabled={disabled} onClick={handleSave}>
            <Stack direction='row' alignItems='center' justifyContent='center' spacing={2}>
                <Typography fontWeight={500}>
                    {variant === 'save' ? 'Uložit' : 'Uložit a přidat dalšího'}
                </Typography>
                {!disabled && <CheckIcon />}
                {disabled && <CircularProgress size={20} />}
            </Stack>
        </Button>
    )
}

export default SaveButton
